import React from 'react';
import { IconProps } from '../types';
const MinecraftFermentedSpiderEye: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="7" y="4" width="1" height="1" fill="rgba(69, 5, 33, 255)" />
<rect x="8" y="4" width="1" height="1" fill="rgba(69, 5, 33, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(69, 5, 33, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(69, 5, 33, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(69, 5, 33, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(123, 13, 39, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(157, 30, 45, 255)" />
<rect x="9" y="5" width="1" height="1" fill="rgba(157, 30, 45, 255)" />
<rect x="10" y="5" width="1" height="1" fill="rgba(123, 13, 39, 255)" />
<rect x="11" y="5" width="1" height="1" fill="rgba(69, 5, 33, 255)" />
<rect x="12" y="5" width="1" height="1" fill="rgba(69, 5, 33, 255)" />
<rect x="5" y="6" width="1" height="1" fill="rgba(57, 6, 32, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(157, 30, 45, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(157, 30, 45, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(211, 154, 136, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(196, 95, 107, 255)" />
<rect x="10" y="6" width="1" height="1" fill="rgba(157, 30, 45, 255)" />
<rect x="11" y="6" width="1" height="1" fill="rgba(123, 13, 39, 255)" />
<rect x="12" y="6" width="1" height="1" fill="rgba(123, 13, 39, 255)" />
<rect x="13" y="6" width="1" height="1" fill="rgba(42, 0, 16, 255)" />
<rect x="5" y="7" width="1" height="1" fill="rgba(57, 6, 32, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(157, 30, 45, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(123, 13, 39, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(196, 95, 107, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(157, 30, 45, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(123, 13, 39, 255)" />
<rect x="11" y="7" width="1" height="1" fill="rgba(157, 30, 45, 255)" />
<rect x="12" y="7" width="1" height="1" fill="rgba(123, 13, 39, 255)" />
<rect x="13" y="7" width="1" height="1" fill="rgba(42, 0, 16, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(57, 6, 32, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(123, 13, 39, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(123, 13, 39, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(157, 30, 45, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(123, 13, 39, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(123, 13, 39, 255)" />
<rect x="11" y="8" width="1" height="1" fill="rgba(196, 95, 107, 255)" />
<rect x="12" y="8" width="1" height="1" fill="rgba(123, 13, 39, 255)" />
<rect x="13" y="8" width="1" height="1" fill="rgba(42, 0, 16, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(69, 5, 33, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(123, 13, 39, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(157, 30, 45, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(123, 13, 39, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(101, 6, 43, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(101, 6, 43, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(157, 30, 45, 255)" />
<rect x="11" y="9" width="1" height="1" fill="rgba(123, 13, 39, 255)" />
<rect x="12" y="9" width="1" height="1" fill="rgba(123, 13, 39, 255)" />
<rect x="13" y="9" width="1" height="1" fill="rgba(42, 0, 16, 255)" />
<rect x="3" y="10" width="1" height="1" fill="rgba(69, 5, 33, 255)" />
<rect x="4" y="10" width="1" height="1" fill="rgba(85, 2, 34, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(85, 2, 34, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(123, 13, 39, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(157, 30, 45, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(123, 13, 39, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(101, 6, 43, 255)" />
<rect x="10" y="10" width="1" height="1" fill="rgba(123, 13, 39, 255)" />
<rect x="11" y="10" width="1" height="1" fill="rgba(85, 2, 34, 255)" />
<rect x="12" y="10" width="1" height="1" fill="rgba(42, 0, 16, 255)" />
<rect x="4" y="11" width="1" height="1" fill="rgba(69, 5, 33, 255)" />
<rect x="5" y="11" width="1" height="1" fill="rgba(40, 9, 34, 255)" />
<rect x="6" y="11" width="1" height="1" fill="rgba(40, 9, 34, 255)" />
<rect x="7" y="11" width="1" height="1" fill="rgba(40, 9, 34, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(85, 2, 34, 255)" />
<rect x="9" y="11" width="1" height="1" fill="rgba(85, 2, 34, 255)" />
<rect x="10" y="11" width="1" height="1" fill="rgba(123, 13, 39, 255)" />
<rect x="11" y="11" width="1" height="1" fill="rgba(42, 0, 16, 255)" />
<rect x="8" y="12" width="1" height="1" fill="rgba(42, 0, 16, 255)" />
<rect x="9" y="12" width="1" height="1" fill="rgba(85, 2, 34, 255)" />
<rect x="10" y="12" width="1" height="1" fill="rgba(101, 6, 43, 255)" />
<rect x="11" y="12" width="1" height="1" fill="rgba(42, 0, 16, 255)" />
<rect x="8" y="13" width="1" height="1" fill="rgba(42, 0, 16, 255)" />
<rect x="9" y="13" width="1" height="1" fill="rgba(123, 13, 39, 255)" />
<rect x="10" y="13" width="1" height="1" fill="rgba(42, 0, 16, 255)" />
<rect x="9" y="14" width="1" height="1" fill="rgba(42, 0, 16, 255)" />
</svg>);
export default MinecraftFermentedSpiderEye;